<script setup lang="ts">
import { RouterLink, useRoute } from 'vue-router'
import { PhBookOpen, PhGraduationCap, PhHouse } from '@phosphor-icons/vue'

const route = useRoute()

const navItems = [
  { path: '/', label: 'Home', icon: PhHouse, exact: true },
  { path: '/quran', label: 'Qur’an', icon: PhBookOpen, exact: false },
  { path: '/learn', label: 'Learn', icon: PhGraduationCap, exact: false },
] as const

function isActive(item: (typeof navItems)[number]) {
  return item.exact ? route.path === item.path : route.path.startsWith(item.path)
}
</script>

<template>
  <nav
    aria-label="Primary"
    class="fixed inset-x-0 bottom-0 z-40 flex items-stretch justify-around border-t border-border bg-card/95 pb-[env(safe-area-inset-bottom)] shadow-[0_-2px_10px_rgba(0,0,0,0.06)] backdrop-blur-xl md:hidden"
  >
    <RouterLink
      v-for="item in navItems"
      :key="item.path"
      :to="item.path"
      class="flex flex-1 flex-col items-center justify-center gap-0.5 py-2 text-[11px] font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring focus-visible:ring-inset"
      :class="isActive(item) ? 'text-primary' : 'text-muted-foreground'"
    >
      <component :is="item.icon" :size="22" :weight="isActive(item) ? 'fill' : 'regular'" />
      {{ item.label }}
    </RouterLink>
  </nav>
</template>
